<template>
  <b-form @submit.prevent="guardar" data-vv-scope="selectedSeccion1">
    <b-form-row>
      <b-col cols="12">
        <b-form-group>
          <label for="nombre">
            Nombre <span style="color: red">(*)</span>
          </label>
          <b-form-input id="nombre"
                        name="nombre"
                        data-vv-as=" "
                        v-validate="'required|max:50'"
                        v-model="selectedSeccion1.nombre"
                        required
          />
          <span class="text-danger span-error small"
                v-text="errors.first('crearActualizarSeccion1.nombre')"
          />
        </b-form-group>
        <b-form-group>
          <label for="sinonimos">
            Sinónimos <span style="color: red">(*)</span>
          </label>
          <b-form-input id="sinonimos"
                        name="sinonimos"
                        data-vv-as=" "
                        v-validate="'required|max:250'"
                        v-model="selectedSeccion1.sinonimos"
                        required
          />
          <span class="text-danger span-error small"
                v-text="errors.first('crearActualizarSeccion1.sinonimos')"
          />
        </b-form-group>
        <b-form-group>
          <label for="usos_identificados">
            Usos identificados <span style="color: red">(*)</span>
          </label>
          <b-form-input id="usos_identificados"
                        name="usos_identificados"
                        data-vv-as=" "
                        v-validate="'required|max:50'"
                        v-model="selectedSeccion1.usos_identificados"
                        required
          />
          <span class="text-danger span-error small"
                v-text="errors.first('crearActualizarSeccion1.usos_identificados')"
          />
        </b-form-group>
        <b-form-group>
          <label for="producto_externo">
            Producto Externo
          </label>
          <b-form-radio-group id="producto_externo"
                              name="producto_externo"
                              v-model="selectedSeccion1.producto_externo"
                              data-vv-as=" "
                              :options="opcionesProductoExterno"
                              style="margin-left: 5px;"
                              buttons
                              :button-variant="selectedSeccion1.producto_externo ? 'outline-primary' : 'outline-secondary'"
                              @change="productoExterno()"

          />
        </b-form-group>
        <b-form-group v-if="selectedSeccion1.producto_externo">
          <label for="id_fabricante">
            Fabricante <span style="color: red">(*)</span>
          </label>
          <el-select id="id_fabricante"
                     name="id_fabricante"
                     v-model="selectedSeccion1.id_fabricante"
                     filterable
                     clearable
                     remote
                     :remote-method="filtrarFabricantes"
                     no-data-text="No hay datos que coincidan"
                     no-match-text="No hay datos que coincidan"
                     required
                     v-validate="{
                        rules: {
                          required: (selectedSeccion1.producto_externo),
                        },
                     }"
          >
            <el-option v-for="fabricante in fabricantes_filtro"
                       :key="fabricante.id"
                       :label="fabricante.nombre"
                       :value="fabricante.id"
            >
            </el-option>
          </el-select>
          <span class="text-danger span-error small"
                v-text="errors.first('selectedSeccion1.id_fabricante')"
          />
        </b-form-group>
        <b-form-group v-if="selectedSeccion1.producto_externo">
          <label>
            Dirección
          </label>
          <b-form-input plaintext
                        id="direccion"
                        name="direccion"
                        v-model="fabricante.direccion"
          ></b-form-input>
        </b-form-group>
        <b-form-group v-if="selectedSeccion1.producto_externo">
          <label>
            Teléfono
          </label>
          <b-form-input plaintext
                        id="telefono"
                        name="telefono"
                        v-model="fabricante.telefono"
          ></b-form-input>
        </b-form-group>
        <b-form-group v-if="selectedSeccion1.producto_externo">
          <label>Teléfono de emergencia
            <span class="text-danger">(*)</span></label
          >
          <b-form-input plaintext
                        id="telefono_de_emergencia"
                        name="telefono_de_emergencia"
                        v-model="fabricante.telefono_de_emergencia"
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-form-row>

    <hr>
    <FooterButtons back="/fds/listar" />
  </b-form>
</template>

<script>
import Swal from 'sweetalert2';
import {mapActions, mapMutations, mapState} from 'vuex';
import FooterButtons from '../../componentes/FooterButtons';

export default {
  name: "FDS-Seccion1",
  components: {
    FooterButtons
  },
  data() {
    return {
      opcionesProductoExterno: [
        { text: 'No', value: 0 },
        { text: 'Si', value: 1 },
      ]
    }
  },
  async created() {
    await this.setSeccionActual(1);
    let id_empresa = await this.obtenerIdEmpresaUsuario();
    await this.setIdEmpresaFdsProducto(id_empresa);
    if (this.$route.params.id_fds_producto !== undefined) {
      let id_fds_producto = this.$route.params.id_fds_producto;
      let data = {
        id_empresa: id_empresa,
        id_fds_producto: id_fds_producto,
      };
      await this.getSeccion(data);
      await this.setIdFdsProductoSeccion(id_fds_producto);
      await this.productoExterno();
      if (this.selectedSeccion1.producto_externo) {
        await this.buscarFabricante(this.selectedSeccion1.id_fabricante);
      }
    } else {
      await this.resetSeccion();
      await this.resetFabricante();
    }
    await this.configTipoDocumento();
  },
  computed: {
    ...mapState('fds_productos',[
      'id_empresa',
      'accion',
      'selectedSeccion1',
      'tipo_documento',
    ]),
    ...mapState("productos", [
      "fabricantes_filtro",
    ]),
    ...mapState("fabricantes", [
      "fabricante"
    ]),
  },
  watch: {
    async 'selectedSeccion1.id_fds_producto'(value) {
      if (value !== null && this.accion === 'crear') {
        let data = {
          id_empresa: this.id_empresa,
          id_fds_producto: value,
        };
        await this.getSeccion(data);
      }
    },
    async 'selectedSeccion1.id_fabricante'(value) {
      if (value !== '' && value !== null) {
        await this.buscarFabricante(value);
      } else {
        await this.resetFabricante();
      }
    }
  },
  methods: {
    async configTipoDocumento() {
      if (this.accion === 'crear') {
        await this.setTipoDocumentoSeccion1(this.tipo_documento);
      }
    },
    async guardar() {
      /*if (this.selectedSeccion1.producto_externo && (this.selectedSeccion1.id_fabricante === null || this.selectedSeccion1.id_fabricante === '')) {
        await Swal.fire('El Fabricante es obligatorio', 'Seleccione un fabricante e intente nuevamente', "error");
        return false;
      }*/
      if (await this.$validator.validate()) {
        if (this.accion === 'crear') {
          await this.crearSeccion();
          await this.$router.push(`/fds/productos/${this.selectedSeccion1.id_fds_producto}`);
        } else if (this.accion === 'editar') {
          await this.actualizarSeccion();
        }
      }
    },
    async productoExterno() {
      if (!this.selectedSeccion1.producto_externo) {
        await this.setIdFabricante(null);
        await this.resetFabricante();
      }
    },
    async buscarFabricante(id_fabricante) {
      await this.load(true);
      await this.obtenerFabricante(id_fabricante);
      await this.establecerFabricantesFiltro([this.fabricante]);
      await this.load(false);
    },
    async filtrarFabricantes(q) {
      if (q.length > 2) {
        await this.obtenerFabricantesFiltro(q);
      }
    },
    ...mapActions('dashboard', [
      'obtenerIdEmpresaUsuario',
    ]),
    ...mapActions('fds_productos', [
      'getSeccion',
      'crearSeccion',
      'actualizarSeccion'
    ]),
    ...mapActions("productos", [
      "obtenerFabricantesFiltro",
    ]),
    ...mapActions("fabricantes", [
      "obtenerFabricante",
    ]),
    ...mapMutations('fds_productos',[
      'setIdEmpresaFdsProducto',
      'setSeccionActual',
      'setIdFdsProductoSeccion',
      'resetSeccion',
      'setIdFabricante',
      'setTipoDocumento',
      'setTipoDocumentoSeccion1',
    ]),
    ...mapMutations('productos', [
      'setFabricantes',
      'establecerFabricantesFiltro'
    ]),
    ...mapMutations("fabricantes", [
      "resetFabricante",
    ]),
    ...mapMutations("dashboard", [
      "load"
    ])
  }
}
</script>
